export enum ActionAtLoad {
    ADD_TO_PROJECT = 'openAddToProjectModal', // add to project modal is auto opened on the check step of the configurator
    ADD_DOOR = 'useAddDoorMutation', // execute addDoorMutation on the check step of the configurator
    SHARE_DOOR = 'useShareDoor', // execute the share door mutation on the check step of the configurator
    MIGRATE_DOOR = 'useMigrateDoor', // execute the migrate door mutation on the check step of the configurator
    SEND_CLAIM_CUSTOMER_MAIL = 'sendClaimCustomerMail', // send claim customer mail on the check step of the configurator
    ASK_QUOTATION = 'askQuotation', // execute the ask quotations on the check step of the configurator
    DIRECT_ORDER = 'directOrder',
    ACCEPT_OFFER = 'acceptOffer',
    LOGIN_TO_SAVE_PROJECT = 'loginToSaveProject', // change project name after non-logged in user has logged in is auto-opened
    REQUEST_FLOW = 'requestFlow',
    VIEW_OFFER = 'viewOffer',
    CHECK_ACTIVE_PROJECT_ID = 'checkActiveProjectId', //After login by dealer, the active projectId needs to be added to the url
}

export const ActionAtLoadValues = [...Object.values(ActionAtLoad)] as const;
export type ActionAtLoadType = typeof ActionAtLoadValues[number];
